import React, {useContext} from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {HotelCardContext} from 'components/HotelCardContext'
import {getHotel} from 'modules/sapiSearch/selectors'
import {SelectedElement} from 'utils/selectedElement'

import {Box} from '@vio/atlas/helpers/Box'
import {Image} from '@vio/atlas/Image'
import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'

import {imageProvider} from '../../../utils/imageProvider'
import {GALLERY_WIDTH} from '../HotelCardLayout/HotelCardLayout'
import {GalleryLoading} from './GalleryLoading'

const GalleryImage = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
`

export const GalleryWithFetchPriority = React.memo(function Gallery({
  isPriorityCard
}: {
  isPriorityCard: boolean
}) {
  const {hotelId} = useContext(HotelCardContext)
  const hotel = useSelector(state => getHotel(state, hotelId))
  const {brandMainHotelImageIndex} = useBrand()
  if (!hotel) return <GalleryLoading />

  const primaryImage = hotel.imageURIs?.[brandMainHotelImageIndex || 0] ?? ''

  return (
    <Box
      display="flex"
      flexDirection="column"
      minHeight="100%"
      height="100%"
      width={`${GALLERY_WIDTH}px`}
      overflow="hidden"
    >
      <Box
        data-id={SelectedElement.Image}
        display="flex"
        flexDirection="column"
        flex="1"
        position="relative"
        justifyContent="center"
      >
        <Box
          position="absolute"
          width="100%"
          height="100%"
          transition={isPriorityCard ? '' : 'opacity 500ms ease-in-out'}
        >
          <GalleryImage>
            <Image
              url={primaryImage}
              imageProvider={imageProvider}
              size="mobileCard"
              resizingType="fill"
              isResponsive
              loading={isPriorityCard ? 'eager' : 'lazy'}
              fetchPriority={isPriorityCard ? 'high' : 'auto'}
            />
          </GalleryImage>
        </Box>
      </Box>
    </Box>
  )
})
